import { router } from "@smakecloud/api-client-helper";
import { list } from "./list";

export const BasicSettingsTimezones = router({
    list,
});
